export default "__VITE_ASSET__DRBhUMV$__"